import './clan-referral-bonus.css';
import { Gift, Sparkles, Users } from 'lucide-react';

export const ClanReferralBonus = () => (
  <div className="clanReferralBonus-container">
    <div className="clanReferralBonus-blur clanReferralBonus-blurTop" />
    <div className="clanReferralBonus-blur clanReferralBonus-blurBottom" />

    <div className="clanReferralBonus-content">
      <Users className="clanReferralBonus-iconUsers" stroke="#90F7FF" />

      <div className="clanReferralBonus-text">
        <h2 className="clanReferralBonus-title">
          Beneficio de Clan
          <Sparkles
            className="clanReferralBonus-iconSparkles"
            stroke="#CAFB10"
          />
        </h2>

        <p className="clanReferralBonus-description">
          Por cada{' '}
          <span className="clanReferralBonus-highlight">
            miembro de tu clan
          </span>{' '}
          que compre una o más tarjetas en esta liga, recibirás automáticamente{' '}
          <span className="clanReferralBonus-highlight">
            1 tarjeta de regalo
          </span>{' '}
          que podrás canjear en esta misma temporada.
        </p>

        <div className="clanReferralBonus-box">
          <Gift className="clanReferralBonus-iconGift" stroke="#CAFB10" />

          <div className="clanReferralBonus-boxText">
            <p className="clanReferralBonus-boxTitle">
              <strong className="clanReferralBonus-strong">
                ¿Cómo funciona?
              </strong>
            </p>

            <ul className="clanReferralBonus-list">
              <li>
                • Un referido compra → Recibes 2 tarjeta de regalo (1 en la liga + 1 en la arena)
              </li>
              <li>• Sin límite de referidos por temporada</li>
              <li>• Las tarjetas de regalo se pueden usar inmediatamente</li>
              <li>• Válido solo para miembros activos de tu clan</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);
